<template>
  <a-drawer
    :width="400"
    :visible="visible"
    :closable="false"
    :headerStyle="{paddingTop:'0px'}"
    :bodyStyle="{background:'#fff',padding: 0 }"
    :drawerStyle="{background:'#fff',overflowY:'hidden'}"
    @close="handleCancel"
    cancelText="关闭">
  <div>
    <!-- 头部标题 -->
    <div class="card-header">
      <span class="header-title">平台简况</span>
    </div>
    <div class="customer-detail-card">
      <div class="driver-left">
        <div>
          <img class="driver-top-img" :src="getFileAccessHttpUrl(model.logo || 'https://oss.dimoclub.com/static/driver/default_logo.png')"/>
        </div>
        <div>
          <div style="font-size: 16px" >{{model.platformName}}</div>
          <div style="color: #FF0000" v-if="model.currentStatusStr">{{model.currentStatusStr}}</div>
        </div>
      </div>

      <!-- 信息列表 -->
      <div class="info-list">
        <div class="info-item" >
          <span class="label">客户姓名:</span>
          <span class="value" >
            <span :style="{color:model.driver.driverLabel?'#ff0000':'#2A82E4'}" @click="viewDriverInfo(model.driverId)">{{model.driver.driverName}}</span>
          </span>
        </div>
        <div class="info-item" style="margin-bottom: 10px">
          <span class="label">身份证号:</span>
          <span class="value" :style="{color:'#2A82E4'}">{{model.driver.idNumber}}</span>
        </div>
        <div class="info-item">
          <span class="label">识&ensp;别&ensp;号:</span>
          <span class="value">{{model.identificationNumber}}</span>
        </div>
        <div class="info-item" >
          <span class="label">所属队长:</span>
          <span class="value">{{model.realname}}</span>
        </div>
        <div class="info-item" style="margin-bottom: 10px">
          <span class="label">所属车队:</span>
          <span class="value">{{model.teamName}}</span>
        </div>
      </div>
      <div class="creator-section">
        <div class="info-item">
          <span class="label">创&ensp;建&ensp;人:</span>
          <span class="value cure-info"><img :title="model.createByName" style="border-radius: 10px"  :src="getFileAccessHttpUrl(model.createAvatar)"
                                   v-if="model.createAvatar" alt=""><span>{{ model.createByName }}</span></span>
        </div>
        <div class="info-item">
          <span class="label">创建日期:</span>
          <span class="value">{{model.createTime.substring(0,10)}}</span>
        </div>
      </div>
    </div>
    <driver-new-info ref="driverModel" @ok="submitCallback"></driver-new-info>
  </div>
  </a-drawer>
</template>

<script>
import {getFileAccessHttpUrl} from "@api/manage";
import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
export default {
  name: 'PlatformInfo',
  mixins: [],
  components: {DriverNewInfo: () => import('@views/dm5/DriverModalInfo'),},
  props:{
    model:{
      type:Object,
      default: {}
    }
  },
  data() {
    return {
      getFileAccessHttpUrl:getFileAccessHttpUrl,
      visible:false
    }
  },methods:{
    filterDictTextByCache,
    submitCallback(){
      this.$emit("update",1);
    },handleCancel(){
      this.visible = false;
    },show(){
      this.visible = true;
    },viewDriverInfo(driverId){
      this.$refs.driverModel.disableSubmit = false;
      this.$refs.driverModel.showInfo(null,driverId,{s:'基本信息',leftTab:1,b:''});
    }
  }
}
</script>
<style lang="less" scoped>
@import '~@assets/less/dm5/driver/leftInfo.less';

</style>